import { required, maxLength, numeric, maxValue, url } from 'vuelidate/lib/validators'
import {
  slugValidator,
  slugAsyncValidator,
  validationErrorMessages
} from '@/utils/validations/validations'
import eventsSlugQuery from '@/services/gql/types/Events/queries/eventsSlugs.gql'
const validatorMap = {
  required,
  url
}

export default ({ id, ctx, isNew, eventSchedules, address }) => {
  const isUnique = async value => {
    return await slugAsyncValidator(value, id, eventsSlugQuery, ctx, 'events')
      .then(res => res)
      .catch(err => console.log(err))
  }
  const validations = {
    title: {
      required: { validator: required, message: validationErrorMessages.required },
      maxLength: { validator: maxLength(100), message: validationErrorMessages.maxLength }
    },
    slug: (() => {
      if (isNew) {
        return false
      }
      return {
        isUnique: { validator: isUnique, message: validationErrorMessages.unique },
        required: { validator: required, message: validationErrorMessages.required },
        generalValidation: {
          validator: slugValidator,
          message: validationErrorMessages.slugGeneralMsg
        }
      }
    })(),
    profileId: {
      required: { validator: required, message: 'Обязательное поле' }
    },
    profileType: {
      required: { validator: required, message: 'Обязательное поле' }
    },
    price: {
      required: { validator: required, message: 'Минимальное значение 0' },
      numeric: {
        validator: numeric,
        message: 'Поле принимает только цифровые значения'
      },
      maxValue: {
        validator: maxValue(999999),
        message: 'Превышено максимальное значение'
      }
    },
    ageRestriction: {
      required: { validator: required, message: 'Обязательное поле' }
    },
    bookingType: {
      required: { validator: required, message: 'Обязательное поле' }
    },
    eventSchedules: {
      required: {
        validator: () => !!eventSchedules?.length,
        message: 'Обязательное поле'
      }
    },
    cityId: {
      required: { validator: required, message: 'Обязательное поле' }
    },
    thumbnailId: {
      required: { validator: required, message: 'Обязательное поле' }
    },
    description: {
      required: { validator: required, message: 'Обязательное поле' }
    },
    address: {
      required: {
        validator: () => !!address?.address,
        message: 'Обязательное поле'
      }
    }
  }
  validations.attributes = {}
  if (ctx && ctx.category.attributeKeys) {
    ctx.category.attributeKeys.forEach(attr => {
      if (attr?.vlidationRules?.length) {
        validations.attributes[attr.name] = {}
        attr.validationRules.forEach(attrValidation => {
          if (validatorMap[attrValidation.type]) {
            if (validations.attributes[attr.name].value === undefined) {
              validations.attributes[attr.name].value = {}
            }
            const value = {
              [attrValidation.type]: {
                validator: validatorMap[attrValidation.type],
                message: attrValidation.message
              }
            }
            Object.assign(validations.attributes[attr.name].value, value)
          }
        })
      }
    })
  }
  return validations
}
